import React from 'react'
import PropTypes from 'prop-types'
import CurrencyItem from 'components/CurrencyItem'

export const FeaturedCurrencyCard = ({ currency }) => {
	return <div className='u-margin-horizontal-small'>
		<div className='c-featured-card u-margin-bottom'>
			<CurrencyItem currency={currency} />
			<div className='c-featured-card__rate u-padding-right-small u-margin-top-small u-text--cornflower u-text--large'>
				<span className='c-featured-card__rate__base u-margin-right-small'>{currency.conversion_value} BGN</span>
				<span className={`c-featured-card__rate__growth c-featured-card__rate__growth--${currency.isRising ? 'up' : 'down'}`}></span>
			</div>
		</div>
	</div>
}

FeaturedCurrencyCard.propTypes = {
	currency: PropTypes.shape({
		flag: PropTypes.string,
		name: PropTypes.string,
		abbreviature: PropTypes.string,
		conversion_value: PropTypes.number,
		isRising: PropTypes.bool
	})
}

export default FeaturedCurrencyCard
